import { notify } from '@kyvg/vue3-notification';

import { getKYCIframeUrl } from '@/api/kyc';
import { i18n } from '@/config/i18n';
import { userInfo } from '@/store/authorization';
import { ModalsEnum, openModal } from '@/store/modals';

export const useKYC = async () => {
  if (userInfo.statusVerification === 1) {
    const iframeSrc = await getKYCIframeUrl();
    openModal(ModalsEnum.KYC_FORM, { iframeSrc });
  }

  if (userInfo.statusVerification === 2) {
    notify({
      text: i18n.global.t('kyc.verificationNotify'),
      duration: 5000,
    });
  }
};
